module.exports = {
	gigabyteInBytes: 1073741824,
	gigabyteInKilobytes: 1048576,
	gigabyteInMegabytes: 1024,
	kilobyteInBytes: 1024,
	megabyteInBytes: 1048576,
	megabyteInKilobytes: 1024,
};
